import { FC, ReactNode } from 'react'
import Spinner from 'components/Loading/Spinner'
import { GreyGrey10, Box, Flex } from '@sequencehq/core-components'
import { ExistingEntityLink } from './ExistingEntityLink'
import { LinkEntity } from './LinkEntity'

export const LinkEntityWidget: FC<{
  'data-testid'?: string
  externalEntityLabel: string
  sequenceEntityLabel: string
  serviceName: string
  isLoaded: boolean
  canLink?: boolean
  noLinkFoundText?: string
  linkedAccount: {
    href: string | undefined
    label: string
    canUnlink: boolean
    isPending: boolean
  } | null
  linkModal?: (modalProps: { onClose: () => void }) => ReactNode
  unlinkModal?: (modalProps: { onClose: () => void }) => ReactNode
  showLinkButton?: boolean
  showUnlinkButton?: boolean
}> = ({ showLinkButton = true, showUnlinkButton = true, ...props }) => {
  const LinkModal = props.linkModal
  const UnlinkModal = props.unlinkModal

  return (
    <Box data-testid={props['data-testid']}>
      {props.isLoaded ? (
        <>
          {props.linkedAccount && (
            <ExistingEntityLink
              data-testid={props['data-testid']}
              serviceName={props.serviceName}
              externalEntityLabel={props.externalEntityLabel}
              showUnlinkButton={showUnlinkButton}
              linkedEntity={{
                href: props.linkedAccount.href,
                canUnlink: props.linkedAccount.canUnlink,
                label: props.linkedAccount.label,
                isPending: props.linkedAccount.isPending
              }}
              unlinkModal={UnlinkModal}
            />
          )}
          {!props.linkedAccount && (
            <LinkEntity
              data-testid={props['data-testid']}
              showLinkButton={showLinkButton}
              canLink={props.canLink}
              serviceName={props.serviceName}
              externalEntityLabel={props.externalEntityLabel}
              sequenceEntityLabel={props.sequenceEntityLabel}
              linkModal={LinkModal}
              text={props.noLinkFoundText}
            />
          )}
        </>
      ) : (
        <Flex
          alignItems="center"
          justifyContent="center"
          backgroundColor={GreyGrey10}
          borderRadius="8px"
          height="104px"
        >
          <Spinner />
        </Flex>
      )}
    </Box>
  )
}
